import InteriorDesignForm from "../component/InteriorDesignForm";

const CommercialInteriorDesignCreate = () => {
  return <InteriorDesignForm isEditMode={false} />;
};

export default CommercialInteriorDesignCreate;
